<div class="row">
  <div class="col text-capitalize">
    <h5
      class="m-0 badge py-2 statusFont"
      [ngClass]="{
        'badge-soft-warning':
          _value === 'Pending' ||
          _value === 'In Progress' ||
          _value === 'Registered' ||
          _value === 'היה רוצה להגיע' ||
          _value === 'Responded',
        'badge-soft-success':
          _value === true ||
          _value === 'Active' ||
          _value === 'New' ||
          _value === 'Yes' ||
          _value === 'Approved' ||
          _value === 'Participation' ||
          _value === 'Sent' ||
          _value === 'אישור הגעה' ||
          _value === 'זכה בסאפס' ||
          _value === 'זכה בסאפס' ||
          _value === 'Attended',
        'badge-soft-danger':
          _value === false ||
          _value === 'No Active' ||
          _value === 'Canceled' ||
          _value === 'Rejected' ||
          _value === 'Closed' ||
          _value === 'Inactive' ||
          _value === 'No' ||
          _value === 'NotApproved' ||
          _value === 'Cancelled Registration' ||
          _value === 'No Participation' ||
          _value === 'Cancelled' ||
          _value === 'אישור אי הגעה' ||
          _value === 'ביטול הגעה',
        'badge-soft-info': _value === 'Sent' || _value === 'נשלח' || _value === 'תגובה התקבלה' || _value === 'חדש',
      }"
    >
      {{ (_value.split(' ').join('') | lowercase) + '.value' | translate }}
    </h5>
  </div>
</div>
